/* src/shared/shared-component/filter-dropdown/filter-dropdown.component.css */
.dropdown-container {
  position: relative;
}
.dropdown-trigger {
  width: 100%;
  font-size: 0.875rem !important;
  padding: 0.25rem 0.25rem !important;
  cursor: pointer;
  border: 1px solid var(--text-border);
  background-color: #fff;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.5rem;
}
.dropdown-trigger[disabled] {
  background-color: #f0f0f0;
  cursor: not-allowed;
  border-color: #ccc;
}
.dropdown-arrow {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: var(--optum-blue);
  margin-left: auto;
  transition: transform 0.3s ease;
}
.rotate-arrow {
  transform: rotate(-90deg);
}
.dropdown-content {
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  box-sizing: border-box;
  z-index: 10;
  padding: 10px;
}
.disabled-dropdown {
  pointer-events: none;
  opacity: 0.5;
}
.search-box {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
}
.search-box[disabled] {
  background-color: #f0f0f0;
  cursor: not-allowed;
}
.dropdown-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
}
.dropdown-item:hover {
  background-color: #f0f0f0;
}
.dropdown-item label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.dropdown-item input[type=checkbox] {
  margin-right: 10px;
}
.dropdown-item input[type=checkbox]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.disabled-dropdown {
  pointer-events: none;
  opacity: 0.5;
}
.search-box[disabled] {
  background-color: #f0f0f0;
  cursor: not-allowed;
}
.dropdown-item input[type=checkbox]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.dropdown-item span.disabled-option {
  color: #ccc;
  cursor: not-allowed;
}
.dropdown-container[disabled] {
  pointer-events: none;
  opacity: 0.5;
}
/*# sourceMappingURL=filter-dropdown.component-S22PVA2L.css.map */
